import React, {FC} from "react";
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const ContextMenuOption: FC<{
  icon: IconDefinition,
  text: string,
  close: () => void,
  onClick: () => void,
  style?: 'primary'|'danger',
  disabled?: boolean
}> = props => {

  const style = {
    primary: 'text-brand-800',
    danger: 'text-red-600',
  }[props.style!] || 'text-brand-800'

  return <div onClick={(e) => {
    if (!props.disabled) {
      e.stopPropagation()
      props.onClick()
      props.close()
    }
  }}
  >
    <div className={`flex items-center h-10 px-4 ${style} rounded-xs font-medium text-sm ${props.disabled ? 'text-slate-500' : 'hover:bg-brand-50'} hover:cursor-default`}>
      <FontAwesomeIcon icon={props.icon} className={'mr-4 w-6'}/>
      <span>{props.text}</span>
    </div>
  </div>
}